import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {setCreateButton, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import {Link, useParams} from "react-router-dom";
import {DepartmentService} from "../services/DepartmentService";
import NavFilter from "../components/NavFilter";
import Formatter from "../helpers/formater";
import {AttendanceService} from "../services/AttendanceService";
import Loader from "../components/Loader";
import {Calendar} from 'primereact/calendar';
import {ClientService} from "../services/ClientService";
import {Badge} from "primereact/badge";
import {SelectableGroup} from "react-selectable-fast";
import {createSelectable, SelectAll, DeselectAll} from 'react-selectable-fast'
import {Dialog} from "primereact/dialog";
import {OverlayPanel} from "primereact/overlaypanel";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Tooltip} from "primereact/tooltip";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {Message} from "primereact/message";
import formater from "../helpers/formater";
import {Image} from "primereact/image";
import {ScrollPanel} from "primereact/scrollpanel";


export default function Attendance(props) {

    // const borderSelectionContainer = useRef(null);
    const containerRef = useRef(null);
    const itemClassName = 'mouse-select__selectable';

    const dispatch = useDispatch()
    const locationParams = useParams()
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [groups, setGroups] = useState([])
    const [activeGroup, setActiveGroup] = useState()
    const [activeAdditional, setActiveAdditional] = useState()
    const [navOptions, setNavOptions] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const [month, setMonth] = useState(new Date().getMonth() + 1)
    const [year, setYear] = useState(new Date().getFullYear())
    const [date, setDate] = useState(new Date())
    const [dates, setDates] = useState([])
    const [rows, setRows] = useState({children: [], attendance: []})
    const [dialogVisible, setDialogVisible] = useState(false)
    const [calendarVisible, setCalendarVisible] = useState(true)
    const [summ, setSumm] = useState([])
    const [selectedDays, setSelectedDays] = useState([])
    const [additionals, setAdditionals] = useState([])
    const calendarRef = useRef()
    const op2 = useRef()

    const attendanceCell = ({selectableRef, isSelected, isSelecting, at, date, children}) => {

        let clasess = (getClasses(children.contracts.filter((contract) => contract.type === locationParams.type && ((activeGroup && contract.group_id === activeGroup) || (activeAdditional && activeAdditional === contract.additional_id))), date))

        return (
            <td className={'ms ' + (isSelected || isSelecting ? 'selected' : '') + ' ' + clasess} ref={selectableRef}>
                {at && parseInt(at.status) !== 0 ? getAttendanceBadge(at) : ''}
            </td>
        )
    }
    const SelectableComponent = createSelectable(attendanceCell)

    const getDaysInMonth = (month, year) => (new Array(31)).fill('').map((v, i) => new Date(year, month - 1, i + 1)).filter(v => v.getMonth() === month - 1)

    const types = {
        feedback: 'Необработанные',
        kindergarten: 'Детский клуб',
        additional_class: 'Доп. занятия',
        individual_lesson: 'Индивидуальные',
        summer_camp: 'Летний лагерь',
        school: 'Школа'
    }

    const groupTypes = {
        kindergarten: 'kindergarten_group',
        summer_camp: 'kindergarten_group',
        school: 'school'
    }

    const attendanceStatuses = {
        1: 'Присутствует',
        2: 'Отсутствует',
        4: 'Отдыхает',
        30: 'Экскурсия',
        0: 'Очистить',
        20: 'Каникулы',
        10: 'Нерабочий день',
        3: 'Болеет'
    };

    function updateCounters() {
        let tabs = []
        groups.map((navItem) => {
            tabs.push({
                from: dates[0].toLocaleDateString(),
                to: dates.at(-1).toLocaleDateString(),
                department_id: currentDepartment,
                type: locationParams.type,
                group_id: navItem.id
            })
        })

        if (tabs.length) {
            AttendanceService.GetCount({filters: tabs}).then((result) => {
                let copyNavOptions = JSON.parse(JSON.stringify(navOptions));

                result.map((v, k) => {
                    let g = groups.find((g) => g.id === copyNavOptions[k].query)
                    if (g) {
                        copyNavOptions[k].count = g.places ? (v + ' / ' + g.places) : v;
                    }
                })
                setNavOptions(copyNavOptions)
                setIsLoaded(true)
            })
        }
    }

    useEffect(() => {
        let navData = []
        groups.map((el) => {
            navData.push({
                label: el.name,
                query: el.id,
                count: '0 / 0'
            })
        })
        setNavOptions(navData)
    }, [groups])

    useEffect(() => {
        // setNavOptions([])
        setActiveGroup(false)

            setRows({children: [], attendance: []})

        setActiveAdditional(false)
        dispatch(setSearchString(''))
        dispatch(setSearchHandler(false))
        dispatch(setCreateButton(false))
        dispatch(setTitle(types[locationParams.type] + ', ' + date.toLocaleDateString('ru-RU', {month: 'long'}) + ' ' + date.getFullYear()))
        DepartmentService.getGroups({'filter': {'department_id': currentDepartment}}).then((response) => {
            const groups = response.items.filter((el) => {
                return el.type === groupTypes[locationParams.type]
            })
            setGroups(groups)
            if (groups && groups.length) {
                setActiveGroup(groups[0].id)
            }

        })

        let additionalType = false
        if (locationParams.type === 'additional_class') {
            additionalType = 'additional'
        }
        if (locationParams.type === 'individual_lesson') {
            additionalType = 'individual'
        }

        if (additionalType) {
            DepartmentService.getAdditionals({
                'filter': {
                    'department_id': currentDepartment,
                    'type': additionalType
                }
            }).then((response) => {
                setAdditionals(response.items)
            })
        }

        }, [locationParams, currentDepartment]);

    useEffect(() => {

        setDates(getDaysInMonth(month, year))
        dispatch(setTitle(types[locationParams.type] + ', ' + date.toLocaleDateString('ru-RU', {month: 'long'}) + ' ' + date.getFullYear()))
        // updateCounters()
    }, [month, year])

    const updateData = () => {
        AttendanceService.GetList({
            from: dates[0].toLocaleDateString(),
            to: dates.at(-1).toLocaleDateString(),
            department_id: currentDepartment,
            type: locationParams.type,
            group_id: activeGroup ? activeGroup : '',
            additional_id: activeAdditional ? activeAdditional : ''
        }).then((r) => {
            updateCounters()
            setRows(r)

            let summData = {}
            r.attendance.map((el) => {
                if (parseInt(el.status) === 1) {
                    summData[el.date] = el.date in summData ? (summData[el.date] + 1) : 1;
                }
            })
            setSumm(summData)

            if (['additional_class', 'individual_lesson'].includes(locationParams.type)) {
                setIsLoaded(true)
            }

        })
    }

    useEffect(() => {
        setIsLoaded(false)

        if (dates && dates.length && ['additional_class', 'individual_lesson'].includes(locationParams.type)) {
            // setIsLoaded(true)
            // setRows({children: [], attendance: []})
            // setIsLoaded(true)
        }
        if (dates && dates.length > 0 && ((groups && groups.length && activeGroup) || activeAdditional)) {
            updateData()
        }

    }, [dates, groups, activeGroup, activeAdditional]);



    useEffect(() => {
        setMonth(date.getMonth() + 1)
        setYear(date.getFullYear())
    }, [date])

    function getAttendanceBadge(attendance) {
        return <div
            className={'attendance attendance-' + attendance.status}
            data-pr-tooltip={attendanceStatuses[attendance.status]}
            title={attendanceStatuses[attendance.status]}>{getAttendanceIcon(attendance.status)}</div>
    }

    function getAttendanceIcon(status) {
        if (parseInt(status) === 30) {
            return <i className={'pi pi-eye'}></i>
        }
        if (parseInt(status) === 0) {
            return <i className={'pi pi-eraser'}></i>
        }
        if (parseInt(status) === 20) {
            return <i className={'pi pi-sun'}></i>
        }
        if (parseInt(status) === 10) {
            return <i className={'pi pi-calendar-minus'}></i>
        }
        if (parseInt(status) === 1 || parseInt(status) === 2) {
            return <i className={'pi pi-circle-fill'}></i>
        }
        if (parseInt(status) === 4) {
            return <i className={'pi pi-circle-fill'}></i>
        }
        if (parseInt(status) === 3) {
            return <i className={'pi pi-heart'}></i>
        }
        if (parseInt(status) === 10) {
            return <i className={'pi pi-home'}></i>
        }
    }

    const selectingHandler = (elements) => {
        if(elements && elements.length) {
            setDialogVisible(true)
            setSelectedDays(elements)
        }
    }

    const prevMonthHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setMonth(d.getMonth() - 1)
        setDate(d)
    }
    const nextMonthHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setMonth(d.getMonth() + 1)
        setDate(d)
    }

    const setAttendanceHandler = (status) => {
        setIsLoaded(false)
        let data = []
        selectedDays.map((dayData) => {
            data.push({
                children: dayData.props.children.id,
                date: dayData.props.date,
                status: status,
                contract_type: locationParams.type,
                additional_id: activeAdditional ? activeAdditional : ''
            })
        })
        AttendanceService.Update(data).then((e) => {
            updateData()
        })
        setDialogVisible(false)
    }


    const contractsInCurrentDateInterval = (contracts, date) => {
        let inCurrent = false
        let isStart = false
        let isFinish = false
        let isEnd = false
        let cs = []
        let end = false



        contracts.map((contract) => {
            let from = new Date(contract.date_from)
            let to = new Date(contract.date_to)
            let d1 = new Date(date)


            if (contract.end_date) {
                end = new Date(contract.end_date)
            }


            if (d1.getTime() >= from.getTime() && d1.getTime() <= to.getTime()) {
                inCurrent = true

                if (d1.getTime() === from.getTime()) {
                    isStart = true
                }
                if (d1.getTime() === to.getTime()) {
                    isFinish = true
                }
                if (end && d1.getTime() > end.getTime() && end.getTime() <= to.getTime()) {
                    isEnd = end
                }

                if (isEnd && end && from.getTime() >= end.getTime()) {
                    isEnd = false;
                    end = false;
                }

            }


        })

        if (!inCurrent) {
            cs.push('disabled')
        }
        if (isStart) {
            cs.push('start')
        }
        if (isFinish) {
            cs.push('finish')
        }
        if (isEnd) {
            cs.push('discontinued')
        }

        return cs.join(' ')
    }

    const getClasses = (contracts, date) => {
        return contractsInCurrentDateInterval(contracts, date)
    }



    return (
        <div className={'p-b-10'}>
            <Tooltip target=".attendance"/>
            <div className="card project-list">
                <div className="row">
                    <div className="col-9 align-items-center justify-content-between">

                        {['additional_class', 'individual_lesson'].includes(locationParams.type) === true ?
                            <>
                                {additionals && additionals.length > 0 ?
                                    <Dropdown placeholder={'Выберите предмет'} options={additionals.map((item) => {
                                        return {value: item.id, label: item.name}
                                    })} value={activeAdditional} onChange={(e) => setActiveAdditional(e.target.value)}/>
                                    : <Message text={<>В филиале нет предметов. <Link to={"/departments/" + currentDepartment + "/additional"}>Добавить</Link></>} severity={'warn'}/>}
                            </> :
                            <ScrollPanel style={{ width: '100%', height: '100%' }} className={''}><NavFilter hideAll options={navOptions} handleClick={(e) => {
                                setActiveGroup(e)
                            }} active={activeGroup}
                            /></ScrollPanel>
                        }

                    </div>
                    <div className="col-3 p-r-0">
                        <div className={'d-flex gap-2 flex-shrink-0 justify-content-end p-button-group'}>
                            <Button icon={'pi pi-angle-left'} text={true} severity="secondary"
                                    onClick={(e) => prevMonthHandler()}/>
                            {calendarVisible &&
                                <Calendar ref={calendarRef}
                                          inputClassName={' p-component p-button-secondary p-button p-button-text'}
                                          value={date} onChange={(e) => setDate(e.value)} view="month"
                                          dateFormat="MM yy"/>
                            }
                            <Button icon={'pi pi-angle-right'} text={true} severity={'secondary'}
                                    onClick={(e) => nextMonthHandler()}/>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog header={'Статус посещаемости'} visible={dialogVisible} style={{width: '300px'}}
                    onHide={() => setDialogVisible(false)}>
                <div className={'p-t-15'}>
                    {Object.keys(attendanceStatuses).map((k) => {
                        return (
                            <div className={'attendance-item d-flex align-items-center p-2'}
                                 onClick={(e) => setAttendanceHandler(k)}>
                                <div className={'m-r-10'}>
                                    <div className={"attendance attendance-" + k}>{getAttendanceIcon(k)}</div>
                                </div>
                                <span>{attendanceStatuses[k]}</span>
                            </div>
                        )
                    })}
                </div>
            </Dialog>

            {activeAdditional || !['additional_class', 'individual_lesson'].includes(locationParams.type) ?
            <div className="card">
                <div className="">
                    <SelectableGroup
                        ref={op2}
                        className="main"
                        clickClassName="tick"
                        ignoreList={['.unselectable', '.disabled']}
                        resetOnStart={false}
                        onSelectionFinish={(e) => selectingHandler(e)}
                    >
                        {rows && rows.children && rows.children.length ?
                        <table className={'schedule-table'} ref={containerRef}>
                            <thead>
                            <tr>
                                <th className={'f-12'}>Ребенок</th>
                                {dates.map((date) => {
                                    return (
                                        <th className={'' + (date.getDay() === 0 || date.getDay() === 6 ? 'mutted' : '') + ' ' + (date.getTime() === new Date().setHours(0,0,0,0) ? 'current' : '')}>
                                            <div className={'f-12'}>{date.getDate()}</div>
                                            <div
                                                className={'f-10 f-w-300 text-end '}>{Formatter.dayShortName(date.getDay())}</div>
                                        </th>
                                    )
                                })}
                                <th className={'f-12'}>Итого</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                rows && rows.children.map((child, k) => {
                                    let counter = 0;
                                    return (
                                        <tr>
                                            <td className={'unselectable'}>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className={'list-number'}>{k + 1}.</span>


                                                    <div className={'d-flex align-items-center'}>
                                                        <Image imageClassName="rounded-circle img-40 "
                                                               className={'rounded-circle overflow-hidden m-r-10'}
                                                               alt=""
                                                               src={'http://yii2.easytickets.pro' + child.avatar}
                                                               preview/>

                                                        <Link to={'/client/' + child.object.id}>{child.fio}</Link>
                                                    </div>

                                                </div>
                                            </td>
                                            {dates.map((date) => {
                                                const d = formater.dateWithOffset(date)
                                                const at = rows.attendance.find((el) => el.date === d && el.children_id === child.id)
                                                if (at && parseInt(at.status) === 1) {
                                                    counter++;
                                                }
                                                // считаем кол-во посещений
                                                return <SelectableComponent at={at} children={child} date={d}/>
                                            })}
                                            <td className={'f-12'}>{counter}</td>
                                        </tr>
                                    )
                                })}
                            <tr>
                                <td className={'f-12'}>Итого присутствует:</td>
                                {dates.map((date) => {
                                    const offset = date.getTimezoneOffset()
                                    const d = new Date(date.getTime() - (offset * 60 * 1000)).toISOString().split('T')[0]
                                    return (
                                        <td className={'f-12'}>{summ[d] ? summ[d] : 0}</td>
                                    )
                                })}
                                <td rowSpan={2}></td>
                            </tr>

                            {!isLoaded && <Loader/>}

                            </tbody>
                        </table>
                        : <div className={'p-3'}><Message text={'Нет контрактов в выбранный период.'} severity={'warn'}/></div>}
                    </SelectableGroup>

                </div>
            </div>
             : ''}
        </div>
    )
}